export const getTrendDirectionDown = (currentScore?: number, previousScore?: number) => {
  if (currentScore && previousScore) {
    if (currentScore !== previousScore) {
      return currentScore < previousScore;
    }
  }
};
